<div class="settings-heading">Loan Characteristics Mapping</div>
<div *ngIf="selectedMapping">
    <mat-tab-group
        #mappingTabBar
        (selectedTabChange)="tabChangeHandler($event)"
        mat-stretch-tabs
        class="stretched-tabs"
    >
        <mat-tab *ngFor="let tab of tabs" [label]="tab.label"></mat-tab>
    </mat-tab-group>
    <mapping-table
        [mappingDescription]="selectedMapping.mappingDescription"
        [mappingData]="selectedMapping.clientLookupDataModel"
        [mappingTypes]="selectedMapping.mappingTypes"
        [mappingTitle]="selectedMapping.mappingTitle"
        [mappingSort]="mappingSort"
        [loading]="loading"
    >
    </mapping-table>
</div>
